import React from "react"
import { Button, Col, ControlLabel, FormControl, FormGroup, Row } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import ProcessesStatus from "../fragments/ProcessesStatus"
import { blockingFetchService } from "../../lib/blockingFetch"
import apiServerApi from "../../redux/sagas/apiServerApi"
import Authenticated from "../../lib/Authenticated"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"
import './index.css'

class TermsAndConditionsScreen extends React.Component {

  state = {
    tAndC: '',
    running: false,
    success: false,
    error: null,
    isUpdated: false,
  }

  authenticated = new Authenticated()
  isSuper = this.authenticated.isSuper()

  componentDidMount() {
    this.loadTAndCFromServer(this.isSuper, false)
  }

  /**
   * Title text
   * 
   * @returns string
   */
  titleText = () => this.isSuper 
    ? 'Generic Terms and Conditions'
    : 'Organization Terms and Conditions'

  loadTAndCFromServer(loadDefault, isUpdated) {

    this.setState({ running: true })

    blockingFetchService(
      accessToken => loadDefault ? apiServerApi.getDefaultTAndC(accessToken) : apiServerApi.getLastTAndC(accessToken), 
      resp => this.setState({
        tAndC: resp.data,
        isUpdated: isUpdated,
      }),
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  validateData = tAndC => !!tAndC

  /**
   * Save to server
   */
  saveTAndC() {

    const { tAndC } = this.state

    if(this.validateData(tAndC)) {

      this.setState({ running: true })
      const data = { data: tAndC }

      blockingFetchService(
        accessToken => apiServerApi.saveTAndC(accessToken, data),
        resp => {
          this.setState({
            tAndC: resp.data,
            isUpdated: false,
          })
        },
        error => this.setState({ error: error.text }),
        _ => this.setState({ running: false })
      )
    }
    else {
      this.setState({ error: 'Invalid text!' })
    }
  }

  valueChanged = newValue => this.setState({
    tAndC: newValue,
    error: null,
    isUpdated: true,
  })

  isValidURL = text => {
    const regexp = new RegExp("^(http://www.|https://www.|http://|https://)?[a-z0-9]+([.-]{1}[a-z0-9]+)*.[a-z]{2,5}(:[0-9]{1,5})?(/.*)?$")
    return text && text.indexOf('.') > -1 ? regexp.test(text) : false
  }

  render() {

    const { tAndC, running, success, error, isUpdated } = this.state

    return (
      <div>
        <CustomBreadCrumb activeText='Terms and Conditions' data={ [{ url: '/settings', title: 'Settings' }] } />

        <div>
          <Row id="terms-container">
            <Col md={8}>

              <FormGroup controlId="tAndCTextarea">
                <ControlLabel>Enter an URL or a full text</ControlLabel>
                <FormControl componentClass="textarea" placeholder="Type here"
                  value={ tAndC }
                  rows={13}
                  onChange={e => this.valueChanged(e.target.value)} />
              </FormGroup>

              <Row>
                <Col md={6}>
                  <ProcessesStatus error={ error } running={ running } success={ success } />
                </Col>

                <Col md={6} className="btn-block-tandc">

                  {!this.isSuper &&
                    <span>
                      <Button
                        onClick={() => this.loadTAndCFromServer(true, true)}
                        bsStyle="warning">
                        <FontAwesome name='exclamation'/> Load Generic Terms
                      </Button>
                      {' '}
                    </span>
                  }

                  <Button
                    onClick={() => this.loadTAndCFromServer(this.isSuper, false)}
                    bsStyle="default">
                    <FontAwesome name='repeat'/> Reload
                  </Button>
                  {' '}

                  <Button
                    onClick={() => this.saveTAndC()}
                    bsStyle="primary"
                    disabled={ running || !isUpdated }>
                    <FontAwesome name='save'/> Save
                  </Button>
                </Col>
              </Row>
            </Col>

            <Col md={4}>
              <h4>Preview</h4>

              { tAndC &&
                <div id="preview-terms">
                  { this.isValidURL(tAndC) 
                    ? <iframe src={tAndC} sandbox="allow-scripts" height={250} title='Content'></iframe>
                    : <p>
                      { tAndC.split('\n').map((value, index) => <span key={index}>{value}<br/></span>) }
                    </p>
                  }
                </div>
              }
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

export default TermsAndConditionsScreen



// WEBPACK FOOTER //
// ./src/components/Settings/TermsAndConditions.js